// extracted by mini-css-extract-plugin
module.exports = {"bookContainer":"book-module--bookContainer--37UNV","title":"book-module--title--3BoZT","hide":"book-module--hide--3RWOm","grid":"book-module--grid--2cnGe"};